let ExtendableError = require('./extendableError');
module.exports = class FormulaEvaluationException extends ExtendableError {
    constructor(m) {
        super(m);
        this.name = 'FormulaEvaluationException';
    }
};
